/**
 * Tree Navigation Style  enum
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum TREE_NAVIGATION_STYLE {
	SIMPLE = "simple",
	MENU_LEFT = "menu-left",
	MENU_RIGHT = "menu-right"
}

export type TREE_NAVIGATION_STYLE_string = keyof typeof TREE_NAVIGATION_STYLE;

export const TREE_NAVIGATION_STYLE_default: TREE_NAVIGATION_STYLE_string = "SIMPLE";
